import axios from 'axios';
import { getEntraApiAccessToken } from '@/services/auth-utils.js';

function api() {
  return axios.create({
    baseURL: process.env.VUE_APP_ENTRA_API_BASE_URL || 'http://localhost:3000',
    timeout: 30000
  });
}

function normaliseError(error) {
  const responseError = error && error.response && error.response.data && error.response.data.error;
  return {
    code: responseError ? responseError.code : (error && error.code ? error.code : 'UNKNOWN_API_ERROR'),
    message: responseError ? responseError.message : (error && error.message || 'An unexpected error occurred.'),
    correlationId: responseError ? responseError.correlationId : null,
    status: error && error.response ? error.response.status : (error && error.status ? error.status : null),
    details: responseError ? responseError.details : null
  };
}

async function getHeaders() {
  const token = await getEntraApiAccessToken();
  return {
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json'
  };
}

export async function getPresalesFormDefinition() {
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/presales/form-definition', { headers: headers });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function getJiraTicket(issueKey) {
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/presales/jira-ticket/' + encodeURIComponent(issueKey), { headers: headers });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function submitPresalesHandover(payload) {
  try {
    const headers = await getHeaders();
    const response = await api().post('/api/v1/presales/submissions', payload, { headers: headers });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function getPresalesSubmissions(params) {
  params = params || {};
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/presales/submissions', { headers: headers, params: params });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function getPresalesSubmission(submissionId) {
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/presales/submissions/' + submissionId, { headers: headers });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function deletePresalesSubmission(submissionId) {
  try {
    const headers = await getHeaders();
    await api().delete('/api/v1/presales/submissions/' + submissionId, { headers: headers });
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function createOnboardingBoard(submissionId) {
  try {
    const headers = await getHeaders();
    const response = await api().post('/api/v1/onboarding/boards', { submissionId: submissionId }, { headers: headers });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function getOnboardingBoardBySubmission(submissionId) {
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/onboarding/boards/by-submission/' + submissionId, { headers: headers });
    return response.data.board;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function getOnboardingBoards(params) {
  params = params || {};
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/onboarding/boards', { headers: headers, params: params });
    return response.data;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function getOnboardingBoard(boardId) {
  try {
    const headers = await getHeaders();
    const response = await api().get('/api/v1/onboarding/boards/' + boardId, { headers: headers });
    return response.data.board;
  } catch (error) {
    throw normaliseError(error);
  }
}

export async function updateOnboardingTask(boardId, taskId, status) {
  try {
    const headers = await getHeaders();
    const response = await api().patch(
      '/api/v1/onboarding/boards/' + boardId + '/tasks/' + encodeURIComponent(taskId),
      { status: status },
      { headers: headers }
    );
    return response.data.board;
  } catch (error) {
    throw normaliseError(error);
  }
}
